import React, {  } from 'react';
import styles from '../Wyszukiwarka.module.css';
import { useZamowienia } from 'hooks/useZamowienia';

export default function NrZamowieniaKlienta({nr_zamowienia_klienta,setNr_zamowienia_klienta} ){

    const { globalSearch } = useZamowienia();
    const handleSubmit = (event) => {
    event.preventDefault(); // Blokuje przeładowanie strony po wciśnięciu Enter
    globalSearch();
  };

  return(
      <form onSubmit={handleSubmit} className={styles.colData}>

      <label className={styles.labelData}> NR ZAM. KLIENTA </label>
      <input className={styles.inputData} style={{width:"140px"}} type="text"
      value={nr_zamowienia_klienta}
      onChange={(event) => {
         const re = /^[a-zA-Z0-9_+\sąćęłńóśźżĄĘŁŃÓŚŹŻŚĆŹ.-/-ŠšŽžČčĐđ,!:]+$/;
        setNr_zamowienia_klienta(event.target.value);
      }}></input>
    </form>
  );
}